(function () {
  'use strict';

  var CONFIG = {
    countries: window.espServiceableCountries || [],
    cacheKey: 'esp_geo_country',
    traceUrl: '/cdn-cgi/trace',
    hideSelectors: [
      'button[name="add"]',
      '.add-to-cart',
      '.js-bundle-add',
      
    ],
    styleId: 'esp-geo-style'
  };

  var SERVICEABLE = CONFIG.countries.map(function (c) {
    return String(c).trim().toUpperCase();
  });

  function detectCountry() {
    var cached = readCache();
    if (cached) return Promise.resolve(cached);
    return fetch(CONFIG.traceUrl, { headers: { Accept: 'text/plain' } })
      .then(function (res) { return res.ok ? res.text() : ''; })
      .then(function (text) {
        var match = text.match(/(?:^|\n)loc=([A-Z]{2})/);
        var country = match ? match[1] : '';
        if (country) writeCache(country);
        return country;
      })
      .catch(function () { return ''; });
  }

  function readCache() {
    try { return sessionStorage.getItem(CONFIG.cacheKey); } catch (e) { return null; }
  }

  function writeCache(value) {
    try { sessionStorage.setItem(CONFIG.cacheKey, value); } catch (e) {}
  }

  function isServiceable(country) {
    return SERVICEABLE.indexOf(country) !== -1;
  }

  function hideGatedElements() {
    if (document.getElementById(CONFIG.styleId)) return;
    var style = document.createElement('style');
    style.id = CONFIG.styleId;
    style.textContent =
      CONFIG.hideSelectors.join(',') + '{display:none!important;}';
    document.head.appendChild(style);
  }

  function init() {
    if (!SERVICEABLE.length) return;
    detectCountry().then(function (country) {
      if (!country || isServiceable(country)) return;
      onReady(hideGatedElements);
    });
  }

  function onReady(fn) {
    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', fn);
    } else {
      fn();
    }
  }

  init();
})();